import React from 'react';
import {DataLoader} from 'src/js/common';

import {useLoadEnums} from '../hooks';

interface OwnProps extends DataLoader {}
type Props = OwnProps;

export const EnumLoader: React.FC<Props> = (props) => {
  const {apiUrl, id, isHierarchical, children} = props;
  const {isLoading} = useLoadEnums(apiUrl, id ?? apiUrl, isHierarchical ?? false);
  return isLoading ? null : <>{children}</>;
};

EnumLoader.displayName = 'EnumLoader';
